/**
 * Async generator that reads NDJSON from a ReadableStream.
 * Handles buffering, final flush on stream end, and safe error reporting.
 */
export async function* readNDJSONStream<T>(
  reader: ReadableStreamDefaultReader<Uint8Array>,
): AsyncGenerator<T> {
  const decoder = new TextDecoder();
  let buffer = "";
  let lineIndex = 0;

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";

    for (const line of lines) {
      if (!line.trim()) continue;
      try {
        yield JSON.parse(line) as T;
      } catch {
        console.warn(
          `Failed to parse NDJSON (byteLength=${line.length}, offset=${lineIndex})`,
        );
      }
      lineIndex++;
    }
  }

  // Final flush: decode any remaining bytes
  buffer += decoder.decode();
  const remaining = buffer.trim();
  if (remaining) {
    try {
      yield JSON.parse(remaining) as T;
    } catch {
      console.warn(
        `Failed to parse NDJSON (byteLength=${remaining.length}, offset=${lineIndex})`,
      );
    }
  }
}
